import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import CloudUpload from '@mui/icons-material/CloudUpload';
import Close from '@mui/icons-material/Close';
import intl from 'react-intl-universal';
import formatAcceptedFileTypes from 'src/helpers/formatAcceptedFileTypes';

const UploadPad = ({ dropHandler, acceptedFileTypes, closeHandler }) => (
  <Dropzone onDrop={dropHandler} accept={formatAcceptedFileTypes(acceptedFileTypes)}>
    {({ getRootProps, getInputProps }) => (
      <div {...getRootProps({ className: 'attachment' })}>
        <input {...getInputProps()} />
        <CloudUpload className="icon large-icon" />
        <br />
        {intl.get('controls.uploadText')}
        <span className="action-link">{intl.get('controls.uploadBrowse')}</span>
        {closeHandler && (
          <nav className="nav-bar">
            <Close className="icon md" onClick={closeHandler} />
          </nav>
        )}
      </div>
    )}
  </Dropzone>
);

UploadPad.propTypes = {
  dropHandler: PropTypes.func.isRequired,
  acceptedFileTypes: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  closeHandler: PropTypes.func,
};

export default UploadPad;
